import { type FC } from 'react';
import classnames from 'classnames';
import { BuyerProductTileShimmer } from 'dibs-buyer-product-tile/exports/BuyerProductTileShimmer';
import { useServerVarsContext } from '../../global/ServerVarsContext/ServerVarsContext';
import { useBuyerProductTileSize } from '../../shared/hooks/useBuyerProductTileSize';

import styles from './SbRespPlaceholderTile.scss';

type Props = {
    itemsInRow?: 2 | 5;
};

export const SbRespPlaceholderTile: FC<Props> = ({ itemsInRow }) => {
    const tileSize = useBuyerProductTileSize();
    const { isItemTileRedesignTestVariant } = useServerVarsContext();
    if (isItemTileRedesignTestVariant) {
        return <BuyerProductTileShimmer size={tileSize} />;
    }

    return (
        <div
            className={classnames(styles.wrapper, {
                [styles.item5InRow]: itemsInRow === 5,
                [styles.item2InRow]: itemsInRow === 2,
            })}
        >
            <div className={styles.tile}>
                <div className={styles.image} />
                <div className={styles.title} />
                <div className={styles.subtitle} />
                <div className={styles.price} />
            </div>
        </div>
    );
};
